
import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'primereact/chart';

const DailyTaskCard = () => {
    const chartRef = useRef<any>(null);
    const [chartData, setChartData] = useState<any>({});
    const [chartOptions, setChartOptions] = useState<any>({});
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

    const centerPlugin = {
        id: 'centerText',
        beforeDraw: (chart: any) => {
            const ctx = chart.ctx;
            const width = chart.width;
            const height = chart.height;
            ctx.save();
            const dataset = chart.data.datasets && chart.data.datasets[0];
            const total = dataset ? dataset.data.reduce((a: number, b: number) => a + b, 0) : 0;
            const text = String(total);
            const fontSize = Math.round(Math.min(width, height) / 6);
            ctx.font = `bold ${fontSize}px sans-serif`;
            ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--text-900') || '#333';
            const textMetrics = ctx.measureText(text);
            const textX = Math.round((width - textMetrics.width) / 2);
            const textY = Math.round((height + fontSize / 2) / 2);
            ctx.fillText(text, textX, textY);
            ctx.restore();
        }
    };

    const dataset = [
        { name: 'Pick & Drop', value: 100 },
        { name: 'Refueling', value: 200 },
        { name: 'Maintenance', value: 13 }
    ];

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const labels = dataset.map(d => d.name);
        const values = dataset.map(d => d.value);

        const payload = {
            labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: [
                        documentStyle.getPropertyValue('--red-500'),
                        documentStyle.getPropertyValue('--yellow-500'),
                        documentStyle.getPropertyValue('--red-300')
                    ],
                    hoverBackgroundColor: [
                        documentStyle.getPropertyValue('--red-400'),
                        documentStyle.getPropertyValue('--yellow-400'),
                        documentStyle.getPropertyValue('--red-200')
                    ]

                }
            ]
        };

        const options = {
            cutout: '70%',
            responsive: true,
            maintainAspectRatio: true,
            layout: { padding: 0 },
            plugins: { legend: { display: false }, tooltip: { enabled: false } },
            onHover: (event: any, activeElements: any[]) => {
                if (activeElements && activeElements.length > 0) {
                    const el = activeElements[0];
                    const index = typeof el.index === 'number' ? el.index : el._index;
                    setHoveredIndex(typeof index === 'number' ? index : null);
                    return;
                }
                setHoveredIndex(null);
            }
        };

        setChartData(payload);
        setChartOptions(options);
    }, []);

    return (
        <div className="flex gap-1 card ">
            <div className="w-5 ">
                {/* PrimeFlex centering */}
                <div className="flex align-items-center justify-content-center" style={{ height: 120 }}>
                    {/* fixed inner size so chart is centered and doesn't stretch */}
                    <div style={{ width: 120, height: 120 }}>
                        <Chart
                            ref={chartRef}
                            type="doughnut"
                            data={chartData}
                            options={chartOptions}
                            plugins={[centerPlugin]}
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </div>
                </div>
            </div>

            <div className="w-7 pl-3">
                <div>
                    <span className="font-semibold text-lg">Daily Tasks</span>
                </div>

                <ul className="list-none p-0 m-0 mt-3 flex flex-column gap-2">
                    {dataset.map((item, idx) => {
                        const isHovered = hoveredIndex === idx;
                        return (
                            <li key={item.name} className="flex justify-content-between border-round cursor-pointer transition-all">
                <span
                    className="text-gray-700 font-semibold"
                    style={{
                        fontWeight: isHovered ? 900 : 700,
                        transform: isHovered ? 'scale(1.08)' : 'scale(1)',
                        transformOrigin: 'left center',
                        transition: 'transform 120ms ease, font-weight 120ms'
                    }}
                >
                    {item.name}
                </span>
                                <span
                                    className="text-gray-900 font-bold"
                                    style={{
                                        fontWeight: isHovered ? 900 : 700,
                                        transform: isHovered ? 'scale(1.08)' : 'scale(1)',
                                        transformOrigin: 'right center',
                                        transition: 'transform 120ms ease, font-weight 120ms'
                                    }}
                                >
                    {item.value}
                </span>
                            </li>
                        );
                    })}
                </ul>

            </div>
        </div>
    );
};

export default DailyTaskCard;
